import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Icon, Card } from "@mostlycode/ui"

const StyledBgIcon = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 5;
  pointer-events: none;

  svg {
    width: 30rem;
    height: 30rem;
  }
`

const StyledIcon = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 3rem;
    height: 3rem;
  }
`

const StyledContentCard = styled(Card)`
  position: relative;
  overflow: hidden;
  background: ${(props) => props.theme.colors[props.bg]};
  color: ${(props) => props.theme.colors[props.color]};
  height: 100%;
  border-radius: 5px;
  box-shadow: 0 15px 30px rgba(50, 50, 86, 0.2);

  ${(props) => props.theme.media.tablet_landscape_up`

  `}

  > * {
    position: relative;
    z-index: 10;
  }

  & + & {
    margin-top: 0;
  }

  h4 {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    line-height: 1.2;
  }

  > a {
    color: ${(props) => props.theme.colors[props.iconBg]};
    font-weight: bold;
    margin-top: auto;

    svg {
      transition: all ease-out 0.15s;
      transform: translateX(0);
    }

    &:hover {
      svg {
        transform: translateX(1rem);
      }
    }
  }

  > ${StyledIcon} {
    background: ${(props) => props.theme.colors[props.iconBg]};
    width: 6rem;
    height: 6rem;
    border-radius: 50%;
    svg {
      fill: ${(props) => props.theme.colors[props.iconColor]};
    }
  }

  > ${StyledBgIcon} {
    position: absolute;
    transform: translate3d(25%, 35%, 0);

    svg {
      fill: ${(props) => props.theme.colors[props.iconBg]};
      opacity: 0.1;
    }
  }
`

function ContentCard({ children, icon, ...props }) {
  return (
    <StyledContentCard {...props}>
      {icon && (
        <StyledIcon>
          <Icon icon={icon} />
        </StyledIcon>
      )}
      {children}
      {icon && (
        <StyledBgIcon>
          <Icon icon={icon} />
        </StyledBgIcon>
      )}
    </StyledContentCard>
  )
}

export default ContentCard

ContentCard.defaultProps = {}
ContentCard.propTypes = {
  children: PropTypes.node.isRequired,
}
